import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;

  .MuiAutocomplete-root {
    .MuiAutocomplete-inputRoot {
      min-height: 56px;
      height: auto;
    }

    .MuiAutocomplete-input {
      min-width: 120px !important;
      padding: 0 !important;
    }

    .MuiAutocomplete-tag {
      margin: 2px;
      height: 28px;
    }

    .MuiAutocomplete-endAdornment {
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;
